// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__22bdT","approved":"Status_approved__2eFpw","rejected":"Status_rejected__3gdee","expired":"Status_expired__3cBSH","label":"Status_label__e8f8p"};